<template>
  <v-container fluid>
    <v-card shaped outlined class="mt-2">
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-simple-table class="analog-summary-table">
              <template #default>
                <thead>
                  <tr>
                    <th class="text-center analog-summary-col-expert">
                      Выбран у эксперта 1
                    </th>
                    <th class="analog-summary-col-mnn">МНН: лекарственная форма</th>
                    <th class="text-center analog-summary-col-final">
                      Финальный выбор аналогов
                    </th>
                    <th class="text-center analog-summary-col-expert">
                      Выбран у эксперта 2
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in analogSummaryRows"
                    :key="`sum-${row.id}`"
                    :class="{ 'analog-summary-row--active': row.isFocused }"
                  >
                    <td class="text-center analog-summary-col-expert">
                      <v-icon
                        small
                        class="analog-summary-status-icon"
                        :color="summaryStatusColor(row.leftStatus)"
                      >
                        {{ summaryStatusIcon(row.leftStatus) }}
                      </v-icon>
                    </td>
                    <td class="analog-summary-col-mnn">
                      <div
                        class="analog-summary-label"
                        :class="{ 'analog-summary-label--add': row.resultIndex == null }"
                        @click="onSummaryLabelClick(row)"
                      >
                        {{ row.label }}
                      </div>
                    </td>
                    <td class="text-center analog-summary-col-final">
                      <v-checkbox
                        v-if="row.resultIndex != null && row.resultIndex !== 0"
                        class="analog-summary-inline-checkbox"
                        dense
                        hide-details
                        :input-value="row.resultAnal"
                        :title="summaryCheckboxTitle(row)"
                        @change="onSummaryResultToggle(row, $event)"
                      />
                      <v-btn
                        v-else-if="row.resultIndex == null && (row.leftIndex != null || row.rightIndex != null)"
                        small
                        text
                        color="primary"
                        class="analog-summary-add-btn"
                        @click="addToSummaryFromExpertRow(row)"
                      >
                        добавить в сводную
                      </v-btn>
                      <span
                        v-else-if="row.resultIndex === 0"
                        class="analog-summary-main-label text--secondary"
                        title="Предлагаемый ЛП — не включается в итоговый выбор аналогов"
                      >
                        предлагаемый ЛП
                      </span>
                    </td>
                    <td class="text-center analog-summary-col-expert">
                      <v-icon
                        small
                        class="analog-summary-status-icon"
                        :color="summaryStatusColor(row.rightStatus)"
                      >
                        {{ summaryStatusIcon(row.rightStatus) }}
                      </v-icon>
                    </td>
                  </tr>
                  <tr v-if="!analogSummaryRows.length">
                    <td colspan="4" class="text-center text--disabled py-2">
                      Нет данных по аналогам
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card shaped outlined class="mt-2">
      <v-card-text>
        <div class="sticky">
          <CompareRow
            hideUseBtn
            editable
            v-slot="{ value, position, dataResult, isResult }"
          >
            <div
              v-if="isResult && isSummarySelectionEmpty"
              class="analog-summary-select-empty text--secondary text-caption"
            >
              Нет в сводной версии
            </div>
            <AnalogSelect
              v-else
              v-model="selectedData[position]"
              :items="getItems(value, dataResult)"
              :hide-exists="isResult"
              :clearable="!isResult"
              @change="analogSelectChange(position)"
            />
          </CompareRow>
          <CompareRow
            hideUseBtn
            v-slot="{
              value,
              isResult,
              changeResult,
              position,
              dataResult,
              change,
            }"
            dense
          >
            <div class="align-self-center" v-if="dataReady">
              <v-btn
                v-if="isResult && isSummarySelectionEmpty"
                x-small
                text
                class="fit-content"
                color="primary"
                @click="addToSummaryFromExpertRow(focusedSummaryRow)"
              >
                добавить в сводную
              </v-btn>
              <btn-with-confirm
                v-if="isResult"
                v-show="showRemoveBtn(value, position)"
                icon-main="mdi-minus"
                icon-small
                x-small
                left
                text
                color="error"
                class="fit-content"
                @click="toggleAnalItemAL(value, change)"
              >
                не использовать как аналог
              </btn-with-confirm>
              <btn-with-confirm
                v-if="isResult"
                v-show="showAddBtn(value, position)"
                icon-main="mdi-plus"
                icon-small
                x-small
                left
                text
                color="success"
                @click="toggleAnalItemAL(value, change)"
              >
                использовать как аналог
              </btn-with-confirm>
              <btn-with-confirm
                v-if="isResult"
                v-show="showDeleteFromSummaryBtn(value, position)"
                icon-main="mdi-delete"
                icon-small
                x-small
                left
                text
                color="error"
                class="fit-content"
                title="Удалить аналог из сводной версии"
                @click="removeAnalogFromSummary(changeResult, dataResult)"
              >
                удалить из сводной
              </btn-with-confirm>
              <v-btn
                v-if="!isResult"
                x-small
                text
                class="fit-content"
                color="primary"
                title="добавить блок полностью"
                @click="addItemAL(value, changeResult, position, dataResult)"
                :disabled="
                  selectedData[position] === 0 ||
                  !canAddItemAl(value, position, dataResult)
                "
              >
                <v-icon right dark class="mx-2" v-if="position === 2"
                  >mdi-arrow-left-thin</v-icon
                >
                добавить аналог
                <v-icon right dark class="mx-2" v-if="position === 1"
                  >mdi-arrow-right-thin</v-icon
                >
              </v-btn>
            </div>
          </CompareRow>
        </div>

        <v-card
          ref="analogPassport"
          shaped
          outlined
          class="mt-2 analog-passport-card"
        >
          <v-card-title class="pb-0 text-button">Паспорт аналога</v-card-title>
          <v-card-text>
            <!-- паспорт аналога -->
            <v-divider />
            <CompareRow
              root="AL"
              :root-index="selectedData"
              tag="ath"
              v-slot="{ value, change }"
            >
              <AtcTextEditor
                :value="value"
                label="АТХ"
                @change="change"
                @input="change"
                :maxlength="maxLengthAth"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              tag="lForma"
              v-slot="{ value, change }"
            >
              <AutoGrowTextEditor
                :value="value"
                label="Лекарственная форма"
                :rows="2"
                @change="change"
                @input="change"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              tag="condition"
              v-slot="{ value, change }"
            >
              <AutoGrowTextEditor
                :value="value"
                label="Показание"
                :rows="5"
                @change="change"
                @input="change"
              />
            </CompareRow>
          </v-card-text>
        </v-card>

        <!-- Встречается в КР -->
        <v-card outlined class="mt-3">
          <v-card-title class="pb-0 text-button"
            >Клинические рекомендации</v-card-title
          >
          <v-card-text>
            <CompareAnalogCr :selectedAnalog="selectedData" />
          </v-card-text>
        </v-card>

        <!-- Данные об аналогах заполняются и проверяются на последнем этапе повторно -->
        <v-card v-if="showAnalogDataSection" outlined class="mt-3">
          <v-card-title class="pb-0 text-button"
            >Данные об аналогах</v-card-title
          >
          <v-card-text>
            <ReferenceTip
              label='Экспертиза "Данные об аналогах" проводится на последнем этапе!'
            />
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD`"
              tag="0"
              v-slot="{ value, change }"
            >
              <v-switch
                class="mt-0"
                :input-value="value.manual"
                label="Ручная корректировка данных"
                title="Выполнить ручную корректировку данных (отменить ручную корректирвку можно только выполнив замену данных из справочника ЛП)"
                color="secondary"
                disabled
                @change="manual => change({ ...value, manual })"
                :messages="
                  value.manual
                    ? 'Внимание! Данные были откорректированы вручную.'
                    : ''
                "
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD[0]`"
              tag="ru"
              v-slot="{ value, change }"
              :changeUpdate="changeUpdate"
            >
              <v-text-field
                :value="value"
                label="РУ (номер РУ или кол-во РУ)"
                @change="change"
                @input="change"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD[0]`"
              tag="ruEndDate"
              v-slot="{ value, change }"
              :changeUpdate="changeUpdate"
            >
              <v-text-field
                :value="value"
                label="Дата окончания РУ"
                @change="change"
                @input="change"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD[0]`"
              tag="obr"
              v-slot="{ value, change }"
              :changeUpdate="changeUpdate"
            >
              <AutoGrowTextEditor
                :value="value"
                label="Обращение (выпуск в гражданский оборот)"
                @change="change"
                @input="change"
                rows="1"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD[0]`"
              tag="govPack"
              v-slot="{ value, change }"
              :changeUpdate="changeUpdate"
            >
              <v-text-field
                :value="value"
                label="Гос. закупки: упаковки"
                @change="change"
                @input="change"
              />
            </CompareRow>
            <CompareRow
              root="AL"
              :root-index="selectedData"
              :root-sub="`AD[0]`"
              tag="govPrice"
              v-slot="{ value, change }"
              :changeUpdate="changeUpdate"
            >
              <v-text-field
                :value="value"
                label="Гос. закупки: стоимость"
                @change="change"
                @input="change"
              />
            </CompareRow>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import CompareRow from '@/components/compare/CompareRow'
import { copyObject } from '@/lib/objects'
import {
  DEFAULT_CR_ANALOG_AL,
  ATH_NAME_LENGTH,
  ANALOG_SAME_FUNC,
  ANALOG_CR_SAME_FUNC,
} from './const'
import CompareAnalogCr from './CompareAnalogCr'
import AtcTextEditor from '@/components/editors/AtcTextEditor'
import ReferenceTip from '@/components/ReferenceTip'
import btnWithConfirm from '@/components/buttons/btnWithConfirm'
import AutoGrowTextEditor from '@/components/editors/AutoGrowTextEditor'
import AnalogSelect from './analogSelect.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    dataReady: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AtcTextEditor,
    AutoGrowTextEditor,
    CompareRow,
    CompareAnalogCr,
    btnWithConfirm,
    AnalogSelect,
    ReferenceTip,
  },
  data: () => ({
    selectedData: [0, 0, 0],
    renderComponent: true,
    maxLengthAth: ATH_NAME_LENGTH,
    showAnalogDataSection: false,
  }),
  computed: {
    ...mapGetters([
      'compare_expertise_0_Data',
      'compare_expertise_1_Data',
      'compare_data',
    ]),
    analogSummaryRows() {
      const left = this.compare_expertise_0_Data?.AL || []
      const result = this.compare_data?.AL || []
      const right = this.compare_expertise_1_Data?.AL || []

      const keyOf = item =>
        `${String(item?.mnn || '').trim()}|${String(item?.ath || '').trim()}|${String(item?.lForma || '').trim()}`

      const indexMap = arr => {
        const map = new Map()
        arr.forEach((item, idx) => {
          const key = keyOf(item)
          if (!map.has(key) && key !== '||') map.set(key, idx)
        })
        return map
      }

      const leftMap = indexMap(left)
      const resultMap = indexMap(result)
      const rightMap = indexMap(right)
      const keys = new Set([
        ...leftMap.keys(),
        ...resultMap.keys(),
        ...rightMap.keys(),
      ])

      const selected = this.selectedData || [0, 0, 0]
      const rows = Array.from(keys).map((key, idx) => {
        const resultIndex = resultMap.has(key) ? resultMap.get(key) : null
        const leftIndex = leftMap.has(key) ? leftMap.get(key) : null
        const rightIndex = rightMap.has(key) ? rightMap.get(key) : null

        const base =
          (resultIndex != null && result[resultIndex]) ||
          (leftIndex != null && left[leftIndex]) ||
          (rightIndex != null && right[rightIndex]) ||
          {}
        const label = `${base.mnn || '-'}: ${base.lForma || '-'}`.trim()

        return {
          id: `${idx}-${key}`,
          label,
          resultIndex,
          leftIndex,
          rightIndex,
          resultAnal:
            resultIndex != null ? !!result[resultIndex]?.anal : false,
          isFocused:
            (resultIndex != null && resultIndex === selected[0]) ||
            (resultIndex == null &&
              leftIndex != null &&
              leftIndex === selected[1]) ||
            (resultIndex == null &&
              rightIndex != null &&
              rightIndex === selected[2]),
          leftStatus: this.resolveAnalogStatus(left, leftIndex),
          rightStatus: this.resolveAnalogStatus(right, rightIndex),
        }
      })
      return rows.sort((a, b) => {
        if (a.resultIndex == null && b.resultIndex != null) return 1
        if (a.resultIndex != null && b.resultIndex == null) return -1
        if (a.resultIndex != null && b.resultIndex != null) {
          return a.resultIndex - b.resultIndex
        }
        return a.label.localeCompare(b.label)
      })
    },
    focusedSummaryRow() {
      const selected = this.selectedData || [null, null, null]
      return (
        this.analogSummaryRows.find(
          row =>
            (row.resultIndex != null && row.resultIndex === selected[0]) ||
            (row.resultIndex == null &&
              row.leftIndex != null &&
              row.leftIndex === selected[1]) ||
            (row.resultIndex == null &&
              row.rightIndex != null &&
              row.rightIndex === selected[2])
        ) || null
      )
    },
    isSummarySelectionEmpty() {
      return (
        this.selectedData[0] == null &&
        this.focusedSummaryRow != null &&
        this.focusedSummaryRow.resultIndex == null
      )
    },
  },
  methods: {
    ...mapMutations(['COMPARE_PART_DATA']),
    onSummaryLabelClick(row) {
      if (row.resultIndex != null) {
        this.pickSummaryRow(row, 0)
      } else {
        this.$set(this.selectedData, 0, null)
        this.$set(this.selectedData, 1, row.leftIndex ?? null)
        this.$set(this.selectedData, 2, row.rightIndex ?? null)
      }
      this.$nextTick(() => this.scrollToPassport())
    },
    scrollToPassport() {
      const el = this.$refs.analogPassport?.$el || this.$refs.analogPassport
      if (!el) return

      // Sticky-шапка сравнения + sticky-селекты + app bar — иначе тайтл уезжает под них.
      let offset = 16
      const appBar = document.querySelector('.v-app-bar')
      if (appBar) offset += appBar.getBoundingClientRect().height

      document.querySelectorAll('.sticky').forEach(node => {
        const position = window.getComputedStyle(node).position
        if (position === 'sticky' || position === '-webkit-sticky') {
          offset += node.getBoundingClientRect().height
        }
      })

      const top = el.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
    },
    onSummaryResultToggle(row, val) {
      if (row.resultIndex == null || row.resultIndex === 0) return
      this.COMPARE_PART_DATA({
        root: `AL[${row.resultIndex}]`,
        tag: 'anal',
        value: !!val,
      })
      this.$set(this.selectedData, 0, row.resultIndex)
    },
    summaryCheckboxTitle(row) {
      if (row.resultIndex == null) {
        return 'ЛП нет в сводной версии — сначала добавьте аналог'
      }
      if (row.resultIndex === 0) {
        return 'Предлагаемый ЛП — не переключается как аналог'
      }
      return row.resultAnal
        ? 'Используется как аналог в сводной версии'
        : 'Не используется как аналог в сводной версии'
    },
    resolveAnalogStatus(list, index) {
      if (index == null) return 'missing'
      const item = list?.[index]
      if (!item) return 'missing'
      if (item.anal) return 'selected'
      return 'present'
    },
    summaryStatusIcon(status) {
      if (status === 'selected') return 'mdi-checkbox-marked-circle'
      if (status === 'present') return 'mdi-checkbox-blank-circle'
      return 'mdi-checkbox-blank-circle-outline'
    },
    summaryStatusColor(status) {
      if (status === 'selected') return 'success'
      if (status === 'present') return 'error'
      return 'grey lighten-1'
    },
    pickSummaryRow(row, position) {
      const indexByPos = [row.resultIndex, row.leftIndex, row.rightIndex]
      const idx = indexByPos[position]
      if (idx == null) return

      // Если кликают по крайней колонке, но в сводной этой записи ещё нет —
      // добавляем и после этого выставляем синхронизацию left/right.
      if (position > 0 && row.resultIndex == null) {
        this.addToSummaryFromExpertRow(row, position)
        return
      }

      // Обновляем выбранную колонку
      this.$set(this.selectedData, position, idx)

      // Синхронизируем все три селекта по текущей строке сводной,
      // чтобы слева/справа показывались соответствующие препараты.
      if (row.resultIndex != null) {
        this.$set(this.selectedData, 0, row.resultIndex)
      }
      this.$set(this.selectedData, 1, row.leftIndex ?? null)
      this.$set(this.selectedData, 2, row.rightIndex ?? null)
    },
    addToSummaryFromExpertRow(row, expertPosition) {
      const position =
        expertPosition || (row.leftIndex != null ? 1 : row.rightIndex != null ? 2 : 0)
      if (!position) return

      const donorIndex = position === 1 ? row.leftIndex : row.rightIndex
      if (donorIndex == null) return

      const donor = this[`compare_expertise_${position - 1}_Data`]
      if (!donor?.AL?.[donorIndex]) return

      const newData = this.mergeDonorAnalogIntoSummary(
        this.compare_data,
        donor,
        donorIndex
      )
      if (!newData) return

      const resultIndex = newData.AL.findIndex((item, idx) =>
        ANALOG_SAME_FUNC(item, donor.AL[donorIndex])
      )
      if (resultIndex < 0) return

      this.COMPARE_PART_DATA({ value: newData })
      this.$set(this.selectedData, position, donorIndex)
      this.$set(this.selectedData, 0, resultIndex)
      // Синхронизация левой/правой колонки под текущую строку
      this.$set(this.selectedData, 1, row.leftIndex ?? null)
      this.$set(this.selectedData, 2, row.rightIndex ?? null)
    },
    mergeDonorAnalogIntoSummary(summary, donor, donorIndex) {
      const newData = copyObject(summary || { AL: [], CR: [] })
      if (!Array.isArray(newData.AL)) newData.AL = []
      if (!Array.isArray(newData.CR)) newData.CR = []

      const dplp = donor.AL[donorIndex]
      if (!dplp) return null

      let resultIndex = newData.AL.findIndex(el => ANALOG_SAME_FUNC(el, dplp))
      if (resultIndex < 0) {
        resultIndex = newData.AL.push(copyObject(dplp)) - 1
        newData.AL[resultIndex].CR = newData.CR.map(() => DEFAULT_CR_ANALOG_AL())
        if (resultIndex > 0) newData.AL[resultIndex].anal = true
      } else if (resultIndex > 0) {
        newData.AL[resultIndex].anal = true
      }

      const usedCr = []
      ;(dplp.CR || []).forEach((item, i) => {
        if (item?.use && donor.CR?.[i]) {
          usedCr.push({ cr: donor.CR[i], al: item })
        }
      })

      usedCr.forEach(({ cr, al }) => {
        let crIndex = newData.CR.findIndex(el => ANALOG_CR_SAME_FUNC(el, cr))
        if (crIndex < 0) {
          crIndex = newData.CR.push(copyObject(cr)) - 1
          newData.AL.forEach(item => {
            if (!Array.isArray(item.CR)) item.CR = []
            while (item.CR.length < newData.CR.length) {
              item.CR.push(DEFAULT_CR_ANALOG_AL())
            }
          })
        }
        while (newData.AL[resultIndex].CR.length < newData.CR.length) {
          newData.AL[resultIndex].CR.push(DEFAULT_CR_ANALOG_AL())
        }
        newData.AL[resultIndex].CR[crIndex] = copyObject(al)
      })

      return newData
    },
    changeUpdate: () => ({ tag: 'manual', value: true }),
    findAnalogIn(analog, AL) {
      return !!analog && !AL?.find(el => ANALOG_SAME_FUNC(el, analog))
    },
    canAddItemAl(donor, position, dataResult) {
      return this.findAnalogIn(
        donor?.AL[this.selectedData[position]],
        dataResult.AL
      )
    },
    addItemAL(donor, _changeResult, position, dataResult) {
      const index = this.selectedData[position]
      if (index == null || !donor?.AL?.[index]) return

      const newData = this.mergeDonorAnalogIntoSummary(dataResult, donor, index)
      if (!newData) return

      const index0 = newData.AL.findIndex(el =>
        ANALOG_SAME_FUNC(el, donor.AL[index])
      )
      if (index0 < 0) return

      this.COMPARE_PART_DATA({ value: newData })
      this.$set(this.selectedData, position, index)
      this.$set(this.selectedData, 0, index0)
    },

    toggleAnalItemAL(value, change) {
      const index = this.selectedData[0]
      const newData = copyObject(value)

      newData.AL[index].anal = !newData.AL[index].anal
      change(newData)
    },

    getItems(value, result) {
      if (!value?.AL?.length) return []
      return value?.AL.map(({ mnn, lForma, anal, ath, CR }, index) => {
        const item = {
          index,
          mnn,
          lForma,
          anal,
          ath,
        }
        const exist = this.findAnalogIn(item, result?.AL)
        // кол-во упоминаний в КР
        const count = CR?.reduce((cnt, { use }) => cnt + (use ? 1 : 0), 0) ?? 0
        return { ...item, exist, count }
      }).sort((a, b) => {
        if (a.index === 0) return -1
        if (b.index === 0) return 1
        return a.mnn?.localeCompare(b.mnn) || a.lForma?.localeCompare(b.lForma)
      })
    },
    showRemoveBtn(v, position) {
      const selectedItem = this.selectedData[position]
      if (selectedItem == null) return false

      if (selectedItem === 0 || !v.AL[selectedItem].anal) {
        return false
      } else {
        return true
      }
    },
    showAddBtn(v, position) {
      const selectedItem = this.selectedData[position]
      if (selectedItem == null) return false

      if (selectedItem !== 0 && !v.AL[selectedItem].anal) {
        return true
      }
    },
    showDeleteFromSummaryBtn(_v, position) {
      const selectedItem = this.selectedData[position]
      return position === 0 && selectedItem != null && selectedItem !== 0
    },
    analogSelectChange(position) {
      // прошёл выбор аналога
      if (position) {
        const another = position == 1 ? 2 : 1
        const index = this.selectedData[position] ?? -1
        const me = this[`compare_expertise_${position - 1}_Data`]?.AL?.[index]
        const AL = this[`compare_expertise_${another - 1}_Data`]?.AL

        let newIndex = null
        if (me && AL) {
          // пробуем найти соответствие для крайних
          newIndex = AL?.findIndex(el => ANALOG_SAME_FUNC(el, me))
          if (newIndex < 0) newIndex = null
        }
        // ставим найденный аналог по выбранному с другой стороны
        this.$set(this.selectedData, another, newIndex)

        const resultAL = this.compare_data?.AL
        if (me && resultAL) {
          const resultIndex = resultAL.findIndex(el => ANALOG_SAME_FUNC(el, me))
          this.$set(this.selectedData, 0, resultIndex >= 0 ? resultIndex : null)
        }
      }
    },
    removeAnalogFromSummary(changeResult, dataResult) {
      const index0 = this.selectedData[0] ?? 0
      if (index0 === 0 || !dataResult?.AL?.length) return
      const removedAnalog = dataResult.AL[index0]
      if (!removedAnalog) return

      // Удаляем аналог целиком из сводной (compare_data.AL),
      // чтобы он снова считался "нет в сводной".
      const newData = copyObject(dataResult)
      newData.AL.splice(index0, 1)

      // После удаления сдвигается индексация AL — сбрасываем выбор в сводной
      // на предлагаемый ЛП (0).
      this.$set(this.selectedData, 0, 0)

      // Подсветим тот же аналог у эксперта 1/2 (если он там есть),
      // чтобы UI не "потерялся".
      const leftAL = this.compare_expertise_0_Data?.AL || []
      const rightAL = this.compare_expertise_1_Data?.AL || []
      const leftIndex = leftAL.findIndex(el =>
        ANALOG_SAME_FUNC(removedAnalog, el)
      )
      const rightIndex = rightAL.findIndex(el =>
        ANALOG_SAME_FUNC(removedAnalog, el)
      )
      this.$set(this.selectedData, 1, leftIndex >= 0 ? leftIndex : -1)
      this.$set(this.selectedData, 2, rightIndex >= 0 ? rightIndex : -1)

      changeResult(newData)
    },
  },
}
</script>

<style scoped>
.analog-summary-table >>> .v-data-table__wrapper > table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}
.analog-summary-table >>> .v-data-table__wrapper > table > thead > tr > th,
.analog-summary-table >>> .v-data-table__wrapper > table > tbody > tr > td {
  border: 1px solid rgba(0, 0, 0, 0.22) !important;
  height: auto !important;
  padding: 12px 14px !important;
  vertical-align: middle;
  line-height: 1.4;
}
.analog-summary-table >>> .v-data-table__wrapper > table > thead > tr > th {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: rgba(0, 0, 0, 0.75) !important;
  white-space: normal;
  background-color: #f7f7f7;
}
.analog-summary-table >>> .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 15px !important;
}
.analog-summary-col-expert {
  width: 14%;
}
.analog-summary-col-mnn {
  width: 48%;
}
.analog-summary-col-final {
  width: 24%;
}
.analog-summary-table >>> tbody tr.analog-summary-row--active {
  background-color: #e8f4e8;
}
.analog-summary-table >>> tbody tr.analog-summary-row--active td {
  background-color: #e8f4e8;
}
.analog-summary-status-icon {
  pointer-events: none;
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
}
.analog-summary-select-empty {
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.analog-summary-label {
  cursor: pointer;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87);
  font-size: 15px;
  font-weight: 400;
}
.analog-summary-label:hover {
  color: var(--v-primary-base, #1976d2);
}
.analog-summary-inline-checkbox {
  margin: 0 auto;
  padding: 0;
  display: inline-flex;
  justify-content: center;
}
.analog-summary-inline-checkbox >>> .v-input--selection-controls__input {
  margin-right: 0;
}
.analog-summary-main-label {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}
.analog-summary-label--add {
  color: rgba(0, 0, 0, 0.55);
}
.analog-summary-add-btn {
  min-width: 0;
  padding: 0 4px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none;
  letter-spacing: normal;
  white-space: normal;
  height: auto !important;
}
.analog-summary-label--disabled {
  cursor: default;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.25);
}
.fit-content {
  max-width: fit-content;
}
.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 110px;
  z-index: 2;
  background-color: white;
  border-bottom: 1px solid #424242;
}
</style>
